export const trackEvent = (name, payload = {}) => {
  if (window.location.hostname === 'localhost') return;
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, payload);
};
